<script setup lang="ts">
/**
 * 骨架屏方块。
 *
 * 用 `animate-pulse` 而不是转圈：回答正在流式生成时，"内容马上就会出现"
 * 比"正在加载"更接近事实，脉搏式的灰块也不会像转圈那样持续抢注意力。
 */

import { cn } from '../../lib/cn';

const props = defineProps<{ className?: string }>();
</script>

<template>
  <div aria-hidden="true" :class="cn('animate-pulse rounded bg-slate-200/80', props.className)" />
</template>
